import React from "react";
import { CheckIcon, TargetIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { volumes } from "../../data/volumes";
import { MOCKUP_URL } from "../../data/site";
export function VolumesSection() {
  return <section className="bg-white px-4 py-16 sm:py-24" data-id="element-346" data-mp="2rtgpu4cq8iel">
      <div className="mx-auto max-w-5xl" data-id="element-347" data-mp="2rs5cpdxe5yat">
        <SectionHeading eyebrow="Inside the collection" title={<>
              Discover the <span className="text-brand" data-id="element-349" data-mp="2itjytw2v77gd">6 specialized volumes</span> of the Hemodynamic Monitoring Blueprint™
            </>} intro="Each volume focuses on a specific area of hemodynamic monitoring education. Together, they create a structured learning pathway from cardiovascular physiology to simulated clinical reasoning." data-id="element-348" data-mp="2e21ucy1muoqn" />

        <div className="mt-12 space-y-6 sm:space-y-8" data-id="element-350" data-mp="1v63f3hto0l11">
          {volumes.map(v => <article key={v.numeral} className="overflow-hidden rounded-3xl bg-canvas ring-1 ring-line" data-id="element-351" data-mp="1z7f35iww4y74">
              <div className="flex gap-4 bg-navy p-5 sm:gap-6 sm:p-7" data-id="element-352" data-mp="1fl3abtags5qi">
                <div role="img" aria-label={`Volume ${v.numeral} cover`} className="w-24 shrink-0 rounded-lg bg-white bg-no-repeat shadow-lg sm:w-32" style={{
              backgroundImage: `url(${MOCKUP_URL})`,
              backgroundSize: "501.6% auto",
              backgroundPosition: `${v.coverX}% ${v.coverY}%`,
              aspectRatio: "250 / 380"
            }} data-id="element-353" data-mp="1ajnkzp197d2b" />
                <div className="min-w-0 self-center" data-id="element-354" data-mp="16k52t10thg36">
                  <span className="inline-block rounded-md bg-gold px-2.5 py-1 text-xs font-extrabold uppercase tracking-wider text-navy" data-id="element-355" data-mp="11s54te4b4x98">
                    Volume {v.numeral}
                  </span>
                  <h3 className="mt-2 text-xl font-extrabold leading-tight text-white sm:text-3xl" data-id="element-356" data-mp="93puv601954r">{v.title}</h3>
                  <p className="mt-2 text-sm font-medium leading-snug text-brand-sky sm:text-base" data-id="element-357" data-mp="ys515tb1iwpa">{v.tagline}</p>
                </div>
              </div>

              <div className="p-5 sm:p-8" data-id="element-358" data-mp="12qkk9m403kxf">
                <div className="space-y-3 text-base leading-relaxed text-muted" data-id="element-359" data-mp="17jdsijyohbe9">
                  {v.intro.map(p => <p key={p} data-id="element-360" data-mp="1ci8iq6yz628e">{p}</p>)}
                </div>

                <h4 className="mt-6 text-sm font-extrabold uppercase tracking-wider text-navy" data-id="element-361" data-mp="ftiywb3sezjs">Inside Volume {v.numeral}</h4>
                <ul className="mt-3 grid gap-2.5 sm:grid-cols-2 sm:gap-x-6" data-id="element-362" data-mp="jucod8wvomes">
                  {v.inside.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-363" data-mp="ovigp5mmm7ns">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-364" data-mp="ttk0xtvsgd0u" />
                      <span className="text-[15px] font-medium leading-snug text-ink" data-id="element-365" data-mp="20af8gna73ayu">{item}</span>
                    </li>)}
                </ul>

                <div className="mt-6 flex gap-3 rounded-2xl bg-white p-4 ring-1 ring-brand/30" data-id="element-366" data-mp="3po53j2a50mub">
                  <TargetIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-367" data-mp="3krerqr5d8dep" />
                  <p className="text-base leading-snug text-ink" data-id="element-368" data-mp="3fylmm25zj323">
                    <span className="font-extrabold text-brand" data-id="element-369" data-mp="3b0tqevyb4us3">Your takeaway: </span>
                    {v.takeaway}
                  </p>
                </div>
                {v.note && <p className="mt-4 text-xs leading-relaxed text-muted" data-id="element-370" data-mp="36wvvkxg0m64u">{v.note}</p>}
              </div>
            </article>)}
        </div>

        <SectionCta label="I want all 6 volumes today" data-id="element-371" data-mp="2x1u43uy9orz3" />
      </div>
    </section>;
}